import React from "react";

const MultipleAnswerQuestion = () => {
  return <div>MultipleAnswerQuestion</div>;
};

export { MultipleAnswerQuestion };
